import { SignInPage } from '@backstage/core-components';
import { SignInPageProps, oktaAuthApiRef } from '@backstage/core-plugin-api';

const Component = (props: SignInPageProps) => (
  <SignInPage
    {...props}
    auto
    provider={{
      id: 'okta-auth-provider',
      title: 'Okta Sign-in',
      message: 'Sign in with your AppFolio Okta account',
      apiRef: oktaAuthApiRef,
    }}
  />
);

export { Component as SignInPage };
